import { StorageRentFilters } from '@app/infrastructure/api/models';
import { RentInvoicingTab } from './_state';

export class SetRentInvoicingPagination {
  static readonly type = '[Rent Invoicing List] Set Pagination';
  constructor(
    public tab: RentInvoicingTab,
    public itemsPerPage: number,
  ) {}
}

export class SetRentInvoicingListFilters {
  static readonly type = '[Rent Invoicing List] Set List Filters';
  constructor(
    public toDate: string,
    public filters: StorageRentFilters | undefined,
  ) {}
}

export class SetRentInvoicingSearchText {
  static readonly type = '[Rent Invoicing List] Set Search Text';
  constructor(public searchText?: string) {}
}
